import { render, staticRenderFns } from "./EmailSenders.vue?vue&type=template&id=0133f694"
import script from "./EmailSenders.vue?vue&type=script&lang=js"
export * from "./EmailSenders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports